






























import Vue from 'vue';
import Component from 'vue-class-component';
import AmetrasNumberFieldTemplate from '@/fields/text/AmetrasNumberFieldTemplate.vue';
import AmetrasTextAreaFieldTemplate from '@/fields/text-area/AmetrasTextAreaFieldTemplate.vue';
import {AMETRAS_HOLIDAY_UTILS_INST, ExtendedHolidays} from '@/services/holiday.service';
import AmetrasAdvancedButtonTemplate from '@/fields/button/AmetrasAdvancedButtonTemplate.vue';
import Holidays from 'date-holidays';
import moment from 'moment';

@Component({
    components: {AmetrasAdvancedButtonTemplate, AmetrasTextAreaFieldTemplate, AmetrasNumberFieldTemplate}
})
export default class HolidayGeneratorTemplate extends Vue {

    yearFrom = 1970;
    yearTo = 2100;

    exportTemplate = '\"$NAME$\",\"$TYPE$\",\"$DATE$\",\"$COUNTRY$\",\"$STATE$\",\"$REGION$\"\n';

    allHolidayCountriesAndStates: ExtendedHolidays[] = AMETRAS_HOLIDAY_UTILS_INST.getAllPossibleValues();
    selectedHolidayCountriesAndStates: ExtendedHolidays[] = [];

    output: string = '';

    created() {
        for (const currentHoliday of this.allHolidayCountriesAndStates) {
            this.selectedHolidayCountriesAndStates.push(currentHoliday);
        }
    }

    generate() {
        let output = '';
        for (const currentCountry of this.selectedHolidayCountriesAndStates) {
            for (let currentYear = this.yearFrom; currentYear <= this.yearTo; currentYear++) {
                const holidays = new Holidays(currentCountry.holidayCountry, {
                    types: ['public', 'bank', 'school', 'optional']
                }).getHolidays(currentYear);
                for (const currentHoliday of holidays) {
                    output += this.exportTemplate
                        .replace('$NAME$', currentHoliday.name.replace('\"', '\\'))
                        .replace('$TYPE$', currentHoliday.type.replace('\"', '\"\"'))
                        .replace('$DATE$', moment(currentHoliday.date).format('YYYY-MM-DD').replace('\"', '\\'))
                        .replace('$COUNTRY$', currentCountry.holidayCountry.country.replace('\"', '\\'))
                        .replace('$STATE$', (currentCountry.holidayCountry.state || '').replace('\"', '\\'))
                        .replace('$REGION$', (currentCountry.holidayCountry.region || '').replace('\"', '\\'))
                    ;
                }
            }
        }
        this.output = output;
        this.$store.commit('showSnack', {
            message: 'Erfolgreich Generiert',
            color: 'success'
        });
    }

    copy() {
        navigator.clipboard.writeText(this.output).then(() => {
            this.$store.commit('showSnack', {
                message: 'Erfolgreich in die Zwischenablage kopiert',
                color: 'success'
            });
        }, (err) => {
            this.$store.commit('showSnack', {
                message: err,
                color: 'error'
            });
        });
    }

}
